// API Reference: https://www.wix.com/corvid/reference
// “Hello, World!” Example: https://www.wix.com/corvid/hello-world
import { updateMarketoV2 } from 'public/marketo-service.js'
import wixLocation from 'wix-location';
import wixWindow from 'wix-window';

$w.onReady(function () {
    // Write your JavaScript here

    // To select an element by ID use: $w("#elementID")

    // Click "Preview" to run your code
});

export function isEmailValid(email) {
    return /^[a-zA-Z0-9.!#$%&*+/=?^_{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email);
}

export function blogSignupSubmit_click(event) {
    const emailInput = $w('#blogSignupInput');
    if(!isEmailValid(emailInput.value)) {
        emailInput.style.borderColor = '#FF4040';
        return;
    }
    const checkbox = $w('#checkbox1');
    if (!checkbox.checked) {
        // checkbox.style.borderColor = '#FF4040';
        return;
    }
    // $w('#blogSignupSubmit').hide();
    $w('#signupBox1').hide();
    $w('#tyBox1').show();
    const email = $w('#blogSignupInput').value;
    let query = wixLocation.query;
    const dataObj = {
        email,
        UTM_Campaign__c: query.utm_campaign || '',
        UTM_Content__c: query.utm_content || '',
        UTM_Medium__c: query.utm_medium || '',
        UTM_Source__c: query.utm_source || '',
        UTM_Term__c: query.utm_term || '',
        UTM_Campaign_ID: query.utm_campaign_id || '',
        last_Form_Conversion_Type: 'Blog'

    }
    const program = { programName: 'Newsletter Subscription Program' }
    let url = wixLocation.url;
    updateMarketoV2(dataObj, program.programName).then(() => {
        wixWindow.trackEvent("CustomEvent", {
            "event": "website-blog-pages",
            "eventCategory": "Newsletter Subscription",
            "eventAction": "top banner",
            "eventLabel": url
        });
    }).catch(() => $w('#blogSignupSubmit').show())
}


export function checkbox1_change(event) {
	 const checkbox = $w('#checkbox1');
     checkbox.style.borderColor = '#737373'
}


export function blogSignupInput_input(event) {
	const emailInput = $w('#blogSignupInput');
    emailInput.style.borderColor = '#FFFFFF';
}